import React from 'react';
import PropTypes from 'prop-types';

import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Align from '@marvelapp/marvel-ui/align';

import Image from 'marketing-website/components/modules/Image';

export default function ExperienceCard({ title, subtitle, image }) {
  return (
    <div>
      <Spacing size="s" type="margin" position="topBottom">
        <Image hasShadow={false} {...image} />
      </Spacing>
      <Align type="center">
        <Spacing size="s" type="margin" position="bottom">
          <MaxWidth value={340}>
            <Heading tag="h2" weight="semibold" size="xxl" color="black">
              {title}
            </Heading>
          </MaxWidth>
        </Spacing>
        <MaxWidth value={380}>
          <Paragraph size="m" color="black">
            {subtitle}
          </Paragraph>
        </MaxWidth>
      </Align>
    </div>
  );
}

ExperienceCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  subtitle: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/CompetitorAlternatives/ExperienceCard.js